// import moment from 'moment';
const statsStore = {
  state: {
    networkStats: {
      ReferralPayoutAmount: 10,
    },
  },

  mutations: {
    pushNetworkStatsState(state, value) {
      state.networkStats = value;
    },
  },

  actions: {
    updateNetworkStats(context, value) {
      context.commit('pushNetworkStatsState', value);
    },
  },
};

export { statsStore };
